
import { components } from 'react-select'
import SearchIcon from '../../assets/img/icons/Search.svg'
export const DropdownIndicator = props => 
<components.DropdownIndicator {...props}>
    <img alt='search' src={SearchIcon} height="24px" />
</components.DropdownIndicator>